import { useState, useRef } from "react"

export function useStateWithGetter<T>(
  defaultValue: T | (() => T),
): [T, (newState: T | ((oldState: T) => T)) => void, () => T] {
  const [, setUpdateKey] = useState(0)

  const dataRef = useRef<T>()
  const mountedRef = useRef(false)

  if (mountedRef.current === false) {
    mountedRef.current = true

    dataRef.current = typeof defaultValue === "function" ? (defaultValue as any)() : defaultValue
  }

  function setState(newData: any) {
    dataRef.current = typeof newData === "function" ? newData(dataRef.current) : newData

    setUpdateKey(key => key + 1)
  }

  return [dataRef.current!, setState, () => dataRef.current!]
}
